export default __webpack_public_path__ + "static/media/logo-blue.9e071ea1.svg";